export const getActionsTasksAccountsNavPaths = () => ({
    tasksTabPath: "/",
    accountsTabPath: "/accounts",
});
